<template>
  <div>
    <v-btn
      v-if="user.role === 'superviseur'"
      block
      class="warning rounded-pill my-4"
      dark
      @click.stop="dialogForm = true"
      ><v-icon class="mr-4">mdi-school</v-icon> + Formation de masse
    </v-btn>
    <v-dialog
      v-model="dialogForm"
      fullscreen
      hide-overlay
      transition="slide-x-transition"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="dialogForm = false">
              <v-icon>mdi-arrow-left</v-icon> </v-btn
            >Nouvelle Formation de masse {{ projet }}
          </v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container fluid>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="ll_formation"
                    label="Libellé de la Formation"
                    prepend-icon="person"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDateDebutFormattedMomentjs"
                        label="Date de la formation"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="date_formation"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="nombre_hommes_participants"
                    label="Nombre d'hommes participants"
                    prepend-icon="person"
                    :rules="requisNbrparticipants"
                    required
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="nombre_femmes_participants"
                    label="Nombre de femmes participantes"
                    prepend-icon="mdi-face-woman-outline"
                    :rules="requisNbrparticipants"
                    required
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="activite_selected"
                    ref="activite_selected"
                    @change="selectActivite()"
                    dense
                    :items="activites"
                    label="Activités"
                    outlined
                    item-value="ll_parcours"
                    item-text="ll_parcours"
                    :rules="selectRules"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="district_selected"
                    ref="district_selected"
                    @change="setCommunes()"
                    dense
                    :items="user.districts"
                    label="Districts"
                    outlined
                    item-value="id"
                    item-text="ll_district"
                    :rules="selectRules"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="commune_selected"
                    ref="commune_selected"
                    @change="setFokontanys()"
                    dense
                    :items="communes"
                    label="Communes"
                    outlined
                    item-value="id"
                    item-text="ll_commune"
                    :rules="selectRules"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="fokontany_selected"
                    ref="fokontany_selected"
                    dense
                    @change="selectedFokontany()"
                    :items="fokontanys"
                    label="Fokontany"
                    outlined
                    item-value="id"
                    item-text="ll_fokontany"
                    :rules="selectRules"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-4 px-10">
          <v-btn class="rounded-pill neumorphic warning" @click="reset"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newLoading"
            @click="create"
            >Créer la formation</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card flat>
      <v-list two-line subheader>
        <v-list-item
          v-for="(item, index) in filterMyFormationDeMassetoProjet()"
          :key="index"
          @click.stop="detailFormationDeMasse(item)"
        >
          <v-list-item-content>
            <v-list-item-title v-html="item.ll_formation"></v-list-item-title>
            <v-list-item-subtitle>
              Date:
              {{
                $moment(item.date_formation, "YYYY-MM-DD").format(
                  "dddd, Do MMMM YYYY"
                )
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Femmes: {{ item.nombre_femmes_participants }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Hommes: {{ item.nombre_hommes_participants }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon>
              <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    projet: {
      type: String,
      required: true,
    },
    animateur: {
      type: String,
      required: false,
    },
  },
  created() {
    /*     if (this.animateur) {
      this.GetFormationsDeMasseDeSuperviseur(this.animateur);
    } else {
      this.GetFormationsDeMasseDeSuperviseur(this.user.uid);
    } */

    this.setActivite();
    this.getDetailsProjetfromll(this.projet);
  },
  data() {
    return {
      bailleur_selected: "",
      activite_selected: "",
      district_selected: "",
      commune_selected: "",
      fokontany_selected: "",
      projets: [],
      activites: [],
      communes: [],
      fokontanys: [],
      menu2: false,
      date_formation: "",
      date_fin: "",
      newLoading: false,
      dialogForm: false,
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      requisNbrparticipants: [(v) => !!v || "Ce champ est obligatoire"],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      ll_formation: "",
      nombre_hommes_participants: "",
      nombre_femmes_participants: "",
      detailsProjet: [],
    };
  },
  methods: {
    getDetailsProjetfromll(ll_programme) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("projets")
        .where("ll_programme", "==", ll_programme)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.detailsProjet.push({
              ...doc.data(),
              id: doc.id,
            });
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    detailFormationDeMasse(item) {
      this.$router.push({
        path: `/formationsDeMasse/${item.id}`,
      });
    },
    filterMyFormationDeMassetoProjet() {
      const self = this;
      const filtered = _.filter(self.myFormationDeMasse, [
        "ll_programme",
        this.projet,
      ]);

      return filtered;
    },
    create() {
      if (this.$refs.form.validate()) {
        let uuid = this.$uuid.v4();
        var self = this;

        if (this.$refs.activite_selected.selectedItems[0].id_bailleur) {
          var id_bailleur = this.$refs.activite_selected.selectedItems[0]
            .id_bailleur;
          var abbr_bailleur = this.$refs.activite_selected.selectedItems[0]
            .abbr_bailleur;
          var ll_bailleur = this.$refs.activite_selected.selectedItems[0]
            .ll_bailleur;
        } else {
          id_bailleur = "";
          abbr_bailleur = "";
          ll_bailleur = "";
        }

        this.newLoading = true;
        var newFormationdeMasse = {
          id_bailleur,
          abbr_bailleur,
          ll_bailleur,
          fokontany_code_fokontany: this.fokontany_selected,
          date_formation: this.date_formation,
          nombre_hommes_participants: this.nombre_hommes_participants,
          nombre_femmes_participants: this.nombre_femmes_participants,
          ll_theme: this.$refs.activite_selected.selectedItems[0].ll_theme,
          ll_formation: this.ll_formation,
          date_insert: this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          description_parcours: this.$refs.activite_selected.selectedItems[0]
            .description_parcours,
          themes_id_theme: this.$refs.activite_selected.selectedItems[0]
            .themes_id_theme,
          parcours_id_parcours: this.$refs.activite_selected.selectedItems[0]
            .id,
          ll_programme: this.projet,
          users_id_user: this.user.uid,
          ll_parcours: this.activite_selected,
          abbr_parcours: this.$refs.activite_selected.selectedItems[0]
            .abbr_parcours,
          programmes_id_programme: self.detailsProjet[0].id,
          id: uuid,
          nom_responsable: this.user.displayName,
          id_region: this.$refs.district_selected.selectedItems[0].id_region,
          id_district: this.district_selected,
          ll_district: this.$refs.district_selected.selectedItems[0]
            .ll_district,
          id_commune: this.commune_selected,
          ll_fokontany: this.$refs.fokontany_selected.selectedItems[0]
            .ll_fokontany,
          code_fokontany: this.fokontany_selected,
          ll_region: this.$refs.district_selected.selectedItems[0].ll_region,
          ll_commune: this.$refs.commune_selected.selectedItems[0].ll_commune,
        };
        console.log("newFormationdeMasse : ", newFormationdeMasse);

        //Formation de masse
        this.$firebase
          .firestore()
          .collection("formations")
          .doc(uuid)
          .set(newFormationdeMasse, { merge: true });
        console.log("Formation de masse créée id: " + uuid);
        //vuex insert Formation de masse
        this.addOneItem(newFormationdeMasse);

        this.reset();
      } else {
        console.log("veuillez valider d'abord");
      }
    },
    reset() {
      this.$refs.form.reset();
      this.communes = [];
      this.newLoading = false;
      this.dialogForm = false;
    },
    setProjet() {
      let self = this;
      self.projets = [];

      this.$firebase
        .firestore()
        .collection("projets")
        .where("ll_bailleur", "==", this.bailleur_selected)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var projet = doc.data();
            projet.id = doc.id;

            self.projets.push({
              ...projet,
            });
          });
        });
    },
    setActivite() {
      let self = this;
      self.activites = [];
      this.$firebase
        .firestore()
        .collection("activites")
        .where("ll_programme", "==", this.projet)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var activite = doc.data();
            activite.id = doc.id;
            self.activites.push({
              ...activite,
            });
          });
        });
    },

    selectActivite() {
      console.log(this.activite_selected);
    },
    setCommunes() {
      var self = this;
      this.communes = [];
      this.fokontanys = [];

      this.$firebase
        .firestore()
        .collection("communes")
        .where("id_district", "in", [
          this.district_selected.toString(),
          this.district_selected,
        ])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var commune = doc.data();
            commune.id = doc.id;
            self.communes.push({
              ...commune,
            });
            self.communeLoading = false;
          });
        });
    },

    setFokontanys() {
      var self = this;

      this.fokontanys = [];
      this.$firebase
        .firestore()
        .collection("fokontanys")
        .where("id_commune", "in", [
          this.commune_selected.toString(),
          this.commune_selected,
        ])
        .get()
        .then(function (snap) {
          self.fokontanys = [];
          snap.forEach((doc) => {
            var fokontany = doc.data();
            //console.log(fokontany);
            fokontany.id = doc.id;
            self.fokontanys.push({
              ...fokontany,
            });
          });
        });
    },
    selectedFokontany() {
      console.log(this.fokontany_selected);
    },
    ...mapActions({
      GetActivites: "Activites/GetAll",
      GetFormationsDeMasseDeSuperviseur:
        "FormationsDeMasse/GetFormationsDeMasseDeSuperviseur",
      addOneItem: "FormationsDeMasse/addOneItem",
    }),
  },
  computed: {
    computedDateDebutFormattedMomentjs() {
      return this.date_formation
        ? this.$moment(this.date_formation).format("DD-MM-YYYY")
        : "";
    },
    ...mapState({
      bailleurs: (state) => state.Bailleurs.bailleurs,
      user: (state) => state.Auth.user,
      myFormationDeMasse: (state) => state.FormationsDeMasse.FormationsDeMasse,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
